const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const {RichText, InspectorControls, PanelColorSettings, FontSizePicker } = wp.blockEditor;
import { PanelBody, __experimentalBoxControl as BoxControl, SelectControl, ToggleControl, TextControl, BaseControl, RangeControl, __experimentalBorderBoxControl as BorderBoxControl, __experimentalUnitControl as UnitControl, __experimentalInputControl as InputControl, TextareaControl} from '@wordpress/components';
import FontIconPicker from '@fonticonpicker/react-fonticonpicker';
import {icons} from './lib/icons';
import {fontfamilylist} from "./lib/fontfamilylist.js";
registerBlockType('spice-block/spice-icon-list', {
   title:__('Icon List','spice-blocks'),
   category:'spice-blocks',
   icon:<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g>
    <path stroke="#09A223" id="svg_1" d="m4.9087,12l-3.62433,-3.62809l2.38691,0l3.62432,3.62809l-3.62432,3.62809l-2.38691,0l3.62433,-3.62809z" fill="#09A223"/>
    <ellipse ry="1.71569" rx="1.71569" id="svg_3" cy="12" cx="11.06413" stroke-width="0" stroke="#09A223" fill="#09A223"/>
   <ellipse ry="1.71569" rx="1.71569" id="svg_4" cy="12" cx="16.21913" stroke-width="0" stroke="#09A223" fill="#09A223"/>
   <ellipse ry="1.71569" rx="1.71569" id="svg_2" cy="12" cx="21.19485" stroke-width="0" stroke="#09A223" fill="#09A223"/>
   </g></svg>,
   keywords: [
      __('Icon List','spice-blocks'),
      __('Spice Icon List','spice-blocks'),
      __('FSE Icon List','spice-blocks')
      ],
   example: {
      attributes: {
            heading: __('Spice Icon List','spice-blocks')
         }
   },
   attributes: {
      uniqueid:{
		   type:'string',
		},
      iconv:{
		   type:'string',
		   default:'fa fa-angle-right'
		},
      iconListContent: {
         type: 'string',
         default: ''
      },
      iconListSectionPaddings: {
         default: {
            top: '0',
            right: '0',
            bottom: '0',
            left: '0'
         }
      },
      iconListContentPaddings: {
         default: {
            top: '0',
            right: '0',
            bottom: '0',
            left: '10px'
         }
      },
      iconPaddings: {
         default: {
            top: '0',
            right: '0',
            bottom: '0',
            left: '0'
         }
      },
      iconListAlignment:{ 
         type:'string',
         default: 'left'
      },
      iconListAnimation:{
         type:'string',
         default:''
      },
      iconListDurations:{
         type:'string'
      },
      iconListDelay:{
         type:'string'
      },
      iconListSectionBgColor:{
         type:'string'
      },
      iconListColor:{
         type:'string'
      },
      iconListBgColor:{
         type:'string'
      },
      iconListtxtColor:{
         type:'string'
      },
      iconListfontfamily:{
         type:'string',
         default:'Montserrat'
      },
      iconListfontSize:{
         type:'string',
         default:'16px'
      },
      iconListFontWeight:{
         type: 'string',
         default: 400
      },
      iconListLineHeight:{
         type:'number',
         default:28
      },
      iconListTextTransform:{ 
          type:'string'
      },
      iconListTextDecoration:{
         type:'string'
      },
      iconListLetterSpacing:{
         type:'number'
      },
      iconListHideDesktop:{
         type: 'boolean',
         default: true
      },
      iconListHideTablet:{
         type: 'boolean',
         default: true
      },
      iconListHideMobile:{
         type: 'boolean',
         default: true
      },
      iconWidth: {
			type: 'number',
		},
      bordertopradius:{
         type: 'string',
         default: '0px'
      },
      borderrightradius:{
         type: 'string', 
         default: '0px' 
      },
      borderbottomradius:{
         type: 'string',
         default: '0px'
      },
      borderleftradius:{
         type: 'string',
         default: '0px'
      },
      border: {
         default: {
             width: '0',
             color: '#ffffff',
             style: 'solid'
         }
     },
     addclass:{
      type:'string',
    },
    customcss:{
      type:'string',
    }
   },
   edit:function({attributes, setAttributes, clientId}) {
         const { uniqueid, iconv, iconListContent, iconListSectionPaddings, iconListContentPaddings, iconListAlignment, iconListAnimation, iconListDurations, iconListDelay, iconListSectionBgColor, iconListColor, iconListBgColor, iconListtxtColor,
            iconListfontfamily,  iconListfontSize , iconListFontWeight, iconListLineHeight, iconListTextTransform, iconListTextDecoration, iconListLetterSpacing, iconListHideDesktop, iconListHideTablet, iconListHideMobile, iconWidth, bordertopradius, borderrightradius, borderleftradius, borderbottomradius, border, iconPaddings, addclass, customcss } = attributes;
         const animationclass='wow animated ' +attributes.iconListDurations+' '+attributes.iconListAnimation; 
         const displaydesktop=(iconListHideDesktop == false) ? 'hide-desktop' : '';
         const displaytablet=(iconListHideTablet == false) ? 'hide-tablet' : '';
         const displaymobile=(iconListHideMobile == false) ? 'hide-mobile' : '';
         const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;  
         setAttributes({ uniqueid: 'spiceicon' +clientId.slice(0,8) });

         if(iconListfontfamily !=null){
            let url = 'https://fonts.googleapis.com/css2?family='+iconListfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
               let link = document.createElement('link')
                link.href = url;
                link.rel = "stylesheet";
                link.type =  "text/css";
                
                if ( jQuery("body").hasClass("site-editor-php") ) { 
                jQuery('iframe').contents().find("head").append(link);
            }
            else{
               document.head.appendChild(link);
            }
          }
         return([<>
                  <InspectorControls>  
                     <PanelBody initialOpen={true} title={__('General Settings','spice-blocks')}>
                        <PanelBody initialOpen={false} title={__('Spacing','spice-blocks')} className={'spice-panel-edit margin'}>
                           <BoxControl 
                              label={__('Section Padding','spice-blocks')}
                              values={iconListSectionPaddings}
                              sides={['top', 'bottom','left','right']}
                              allowReset={false}
                              units={[]}
                              onChange={(userVal) => setAttributes({
                                 iconListSectionPaddings:{
                                    top:userVal.top,
                                    right:userVal.right,
                                    bottom:userVal.bottom,
                                    left:userVal.left
                                 }
                              })}
                           />
                           <BoxControl 
                              label={__('Content Padding','spice-blocks')}
                              values={iconListContentPaddings}
                              sides={['top', 'bottom','left','right']}
                              allowReset={false}
                              units={[]}
                              onChange={(userVal) => setAttributes({
                                 iconListContentPaddings:{
                                    top:userVal.top,
                                    right:userVal.right,
                                    bottom:userVal.bottom,
                                    left:userVal.left
                                 }
                              })}
                           />
                        </PanelBody>   
                        <PanelBody initialOpen={false} title={__('Animation Effect','spice-blocks')} className={'spice-panel-edit margin'}>
                           <SelectControl
                              label={__('Animation','spice-blocks')}
                              value={ iconListAnimation }
                              options={ [
                                 { label: __('None','spice-blocks'), value: ' ' },
                                 { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                 { label: __('Flash','spice-blocks'), value: 'flash' },
                                 { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                 { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                 { label: __('Shake','spice-blocks'), value: 'shake' },
                                 { label: __('Swing','spice-blocks'), value: 'swing' },
                                 { label: __('Tada','spice-blocks'), value: 'tada' },
                                 { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                 { label: __('Jello','spice-blocks'), value: 'jello' },
                                 { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                 { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                 { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                 { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                 { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                 { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                 { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                 { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                 { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                 { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                 { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                 { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                 { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                 { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                 { label: __('Flip','spice-blocks'), value: 'flip' },
                                 { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                 { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                 { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                 { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                 { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                 { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                 { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                 { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                 { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                 { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                 { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                 { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                 { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                 { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                 { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                 { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                 { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
                              ] }
                              onChange={ (userVal) => setAttributes({ iconListAnimation: userVal }) }					  
                           />  
                           { iconListAnimation !='' && (<>
                           <SelectControl
                              label={__('Durations','spice-blocks')}
                              value={ iconListDurations }
                              options={ [
                                 { label: __('Normal','spice-blocks'), value: ' ' },
                                 { label: __('Slow','spice-blocks'), value: 'slow' },
                                 { label: __('Fast','spice-blocks'), value: 'fast' },
                              ] }
                              onChange={ (userVal) => setAttributes({ iconListDurations: userVal }) }					  
                            />  
                            <TextControl
                                 label={__('Delay(ms)','spice-blocks')}			    
                                 value={iconListDelay}
                                 onChange={(userVal) => setAttributes({ iconListDelay: userVal })}
                            />
                            </>)}
                        </PanelBody> 
                        <PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit margin'}>
                        <ToggleControl
                            label={__('Enable/Disable on Desktop','spice-blocks')}
                            checked={iconListHideDesktop}
                            onChange={(userVal) => setAttributes({ iconListHideDesktop: userVal })}
                        />
                        <ToggleControl
                            label={__('Enable/Disable on Tablet','spice-blocks')}
                            checked={iconListHideTablet}
                            onChange={(userVal) => setAttributes({ iconListHideTablet: userVal })}
                        />
                        <ToggleControl
                            label={__('Enable/Disable on Mobile','spice-blocks')}
                            checked={iconListHideMobile}
                            onChange={(userVal) => setAttributes({ iconListHideMobile: userVal })}
                        />
                    </PanelBody> 
                     </PanelBody>
                     <PanelBody initialOpen={false} title={__('Icon Settings','spice-blocks')} className={'spice-block-side-margin'}>   
                        <FontIconPicker
						         theme={"default spicegbicon "+uniqueid}																				
						         icons={icons}
						         value={iconv}
						         onChange={(userVal) => setAttributes({ iconv: userVal })}
			               /> 
                        <BoxControl 
                           label={__('Icon Padding','spice-blocks')}
                           values={iconPaddings}
                           sides={['top', 'bottom','left','right']}
                           allowReset={false}
                           units={[]}
                           onChange={(userVal) => setAttributes({
                                 iconPaddings:{
                                    top:userVal.top,
                                    right:userVal.right,
                                    bottom:userVal.bottom,
                                    left:userVal.left
                                 }
                           })}
                        />
                        <RangeControl 
			                  label={__('Width(px)','spice-blocks')}
                           value={iconWidth}
                           onChange={(newtext) => setAttributes({ iconWidth: newtext })}
                           min={0}
						         max={500}
			               />
                        <BorderBoxControl
                           label={ __( 'Border' ,'spice-blocks') }
                           enableAlpha={'true'}
                           onChange={(newtext) => setAttributes({ border: newtext })}
                           value={ border }
                        />
                        <BaseControl className="spice-blocks-border-radius" label={__('Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
                           <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ bordertopradius: newtext }) } value={ bordertopradius } placeholder={"Top"} />

                           <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ borderrightradius: newtext }) } value={ borderrightradius } placeholder={"right"} />			        
                           
                           <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ borderleftradius: newtext }) } value={ borderleftradius } placeholder={"left"}/>

                           <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ borderbottomradius: newtext }) } value={ borderbottomradius }  placeholder={"bottom"}/>	       
                        </BaseControl>  
                        <SelectControl
                           label={__('Icon Alignment','spice-blocks')}
                           options= {[
                                { label: __('Left','spice-blocks'), value: 'left' },
                                { label: __('Right','spice-blocks'), value: 'right' },
                           ]}
                           value={iconListAlignment}
                           onChange={ (userVal) => setAttributes({ iconListAlignment: userVal }) }
                        />      
                     </PanelBody>
                     <PanelBody initialOpen={false} title={__('Color Settings','spice-blocks')}>      
                        <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"} title={__('Color Settings','spice-blocks')}
                           colorSettings={[
                              {	
                                 value: iconListSectionBgColor,
                                 enableAlpha:true,
                                 onChange: (colors) => setAttributes({ iconListSectionBgColor: colors }),
                                 label: __('Section Background','spice-blocks')    
                              },
                              {	
                                 value: iconListColor,
                                 enableAlpha:true,
                                 onChange: (colors) => setAttributes({ iconListColor: colors }),
                                 label: __('Icon','spice-blocks') 
                              },
                              {
                                 value: iconListBgColor,
                                 enableAlpha:true,
                                 onChange: (colors) => setAttributes({ iconListBgColor: colors }),
                                 label: __('Icon Background','spice-blocks')
                              },
                              {
                                 value: iconListtxtColor,
                                 enableAlpha:true,
                                 onChange: (colors) => setAttributes({ iconListtxtColor: colors }),
                                 label: __('Text','spice-blocks')
                              },
                           ]}
                        />
                     </PanelBody>
                     <PanelBody initialOpen={false} title={__('Typography','spice-blocks')} className={'spice-block-side-margin'}>
                           <SelectControl
                              label={__(' Font Family','spice-blocks')}
                              value={ iconListfontfamily }
                              options={fontfamilylist}
                              onChange={ (newtext) => setAttributes({ iconListfontfamily: newtext }) }
                           />  
                           <FontSizePicker 
                                 __nextHasNoMarginBottom
                                 value={iconListfontSize}
                                 onChange={(userVal) => setAttributes({iconListfontSize: userVal})}
                           />
                           <SelectControl 
                                 label={__('Font Weight','spice-blocks')}
                                 options= {[
                                    { label: __('Thin','spice-blocks'), value: '100' },
                                    { label: __('Extra Light','spice-blocks'), value: '200' },
                                    { label: __('Light','spice-blocks'), value: '300' },
                                    { label: __('Regular','spice-blocks'), value: '400' },
                                    { label: __('Medium','spice-blocks'), value: '500' },
                                    { label: __('Semi Bold','spice-blocks'), value: '600' },
                                    { label: __('Bold','spice-blocks'), value: '700' },
                                    { label: __('Extra Bold','spice-blocks'), value: '800' },
                                    { label: __('Black','spice-blocks'), value: '900' }
                                ]}
                                 value={ iconListFontWeight}
                                 onChange={(userVal) => setAttributes({iconListFontWeight: userVal})}
                           />
                           <RangeControl 
                                 label={__('line Height(px)','spice-blocks')}
                                 value={iconListLineHeight}
                                 min={0}
                                 max={100}
                                 onChange={(userVal)=> setAttributes({iconListLineHeight:userVal})}
                           />
                           <SelectControl 
                                 label={__('Text Transform','spice-blocks')}
                                 options={[
                                    { label: __('Default','spice-blocks'), value: '' },
                                    { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                    { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                    { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                                ]}
                                 value={iconListTextTransform}
                                 onChange={(userVal) => setAttributes({iconListTextTransform: userVal})}
                           />
                           <SelectControl 
                                 label={__('Text Decoration','spice-blocks')}
                                 options={[
                                    { label: __('Default','spice-blocks'), value: '' },
                                    { label: __('Underline','spice-blocks'), value: 'underline' },
                                    { label: __('Overline','spice-blocks'), value: 'overline' },
                                    { label: __('Line Through','spice-blocks'), value: 'line-through' }
                                ]}
                                 value={iconListTextDecoration}
                                 onChange={(userVal) => setAttributes({iconListTextDecoration: userVal})} 
                           />
                           <RangeControl 
                                 label={__('Letter Spacing','spice-blocks')}
                                 value={iconListLetterSpacing}
                                 min={-10.0}
                                 max={10.0}
                                 onChange={(userVal) => setAttributes({iconListLetterSpacing: userVal})}
                           />
                     </PanelBody>
                     <PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                       <InputControl
                           label={__('Additional Class','spice-blocks')}
                           value={ addclass }
                           onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                       />
                       <TextareaControl
                           label={__('Custom CSS','spice-blocks')}
                           value={ customcss }
                           onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                       />
                   </PanelBody>
                  </InspectorControls>
                  <style dangerouslySetInnerHTML={{
			  __html: [
			     `#block-${clientId} .spice-block-plus-list-icon{
                    padding: ${iconListSectionPaddings.top} ${iconListSectionPaddings.right} ${iconListSectionPaddings.bottom} ${iconListSectionPaddings.left};
                    animation-delay: ${iconListDelay}ms;
                    background:${iconListSectionBgColor};
                 }
                 #block-${clientId} .spice-block-plus-list-icon i{
                  color: ${iconListColor};
                  background:${iconListBgColor};
                  font-size: ${iconWidth}px;
                  border: ${border.width} ${border.style} ${border.color};
                  border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};	
                  padding:${iconPaddings.top} ${iconPaddings.right} ${iconPaddings.bottom} ${iconPaddings.left};
                 }
                 #block-${clientId} .spice-block-plus-list-icon p{
                  color:${iconListtxtColor};
                  font-family:${iconListfontfamily ? iconListfontfamily : 'Montserrat, sans-serif'};
                  font-size: ${iconListfontSize};
                  font-weight: ${iconListFontWeight};
                  line-height: ${iconListLineHeight}px;
                  text-transform:${iconListTextTransform};
                  text-decoration:${iconListTextDecoration};
                  letter-spacing:${iconListLetterSpacing}px;
                  padding:${iconListContentPaddings.top} ${iconListContentPaddings.right} ${iconListContentPaddings.bottom} ${iconListContentPaddings.left};
                 }
                 ${customcss}`
			    ].join('\n')
			  }}>
			         </style>
                  </>,
                  <div className={`spice-block-plus-list-icon ${animationclass} ${displayclass} ${addclass}`}>
                     {iconListAlignment == 'left' && [<>
				         <i className={iconv}></i>
                     </>]}
                     <RichText 
                        tagName="p"
                        placeholder="Write your Content...."
                        value={iconListContent}
                        onChange={(userVal) => setAttributes({iconListContent: userVal})}
                     />
                     {iconListAlignment == 'right' && [<>
				         <i className={iconv} style={{color:iconListColor, background:iconListBgColor}}></i>
                     </>]}
			         </div>
         ]);
     },
     save: function({attributes})
     {
         const { uniqueid, iconv, iconListContent, iconListSectionPaddings, iconListContentPaddings, iconListAlignment, iconListAnimation, iconListDurations, iconListDelay, iconListSectionBgColor, iconListColor, iconListBgColor, iconListtxtColor,
         iconListfontfamily,  iconListfontSize , iconListFontWeight, iconListLineHeight, iconListTextTransform, iconListTextDecoration, iconListLetterSpacing, iconListHideDesktop, iconListHideTablet, iconListHideMobile, iconWidth, bordertopradius, borderrightradius, borderleftradius, borderbottomradius, border, iconPaddings, addclass, customcss } = attributes;
         const animationclass='wow animated ' +attributes.iconListDurations+' '+attributes.iconListAnimation;
         const displaydesktop=(iconListHideDesktop == false) ? 'hide-desktop' : '';
         const displaytablet=(iconListHideTablet == false) ? 'hide-tablet' : '';
         const displaymobile=(iconListHideMobile == false) ? 'hide-mobile' : '';
         const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
         return(<>
         <script> 
				var fontfamily=`{iconListfontfamily}`;
				var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var link2 = document.createElement('link');
				link2.href = url2;
				link2.rel = "stylesheet";
				link2.type =  "text/css";	          
				document.head.appendChild(link2);
			</script>
         <style dangerouslySetInnerHTML={{
			  __html: [
			     `#spice_block_plus_icon_list_${uniqueid}{
                    padding: ${iconListSectionPaddings.top} ${iconListSectionPaddings.right} ${iconListSectionPaddings.bottom} ${iconListSectionPaddings.left};
                    animation-delay: ${iconListDelay}ms;
                    background:${iconListSectionBgColor};
                 }
                 #spice_block_plus_icon_list_${uniqueid}  i{
                  color: ${iconListColor};
                  background:${iconListBgColor};
                  font-size: ${iconWidth}px;
                  border: ${border.width} ${border.style} ${border.color};
                  border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};	
                  padding:${iconPaddings.top} ${iconPaddings.right} ${iconPaddings.bottom} ${iconPaddings.left};
                 }
                 #spice_block_plus_icon_list_${uniqueid} p{
                  color:${iconListtxtColor};
                  font-family:${iconListfontfamily};
                  font-size: ${iconListfontSize};
                  font-weight: ${iconListFontWeight};
                  line-height: ${iconListLineHeight}px;
                  text-transform:${iconListTextTransform};
                  text-decoration:${iconListTextDecoration};
                  letter-spacing:${iconListLetterSpacing}px;
                  padding:${iconListContentPaddings.top} ${iconListContentPaddings.right} ${iconListContentPaddings.bottom} ${iconListContentPaddings.left};
                 }
                 ${customcss}`
			    ].join('\n')
			  }}>
			   </style>
            <div id={`spice_block_plus_icon_list_${uniqueid}`} className={`spice-block-plus-list-icon ${animationclass} ${displayclass} ${attributes.className} ${addclass}`}>
               {iconListAlignment == 'left' && [<>
                  <i className={iconv}></i>
               </>]}
               <RichText.Content 
                  tagName="p"
                  placeholder="Write your Content...."
                  value={iconListContent}
               />
               {iconListAlignment == 'right' && [<>
                  <i className={iconv}></i>
               </>]}
            </div></>);
     }
})